import { useCallback, useEffect, useRef, useState } from 'react';
import { Reservation } from 'types/reservations';
import { ReservationProtectionResponse } from 'types/noShowProtection';
import { fetchReservationProtection } from 'App/NoShowProtection/api';

export default function useReservationProtection(
  restaurantId: string | null,
  reservation: Reservation,
  enabled: boolean
) {
  const generation = useRef(0);
  const [state, setState] = useState<
    (ReservationProtectionResponse & { restaurantId: string; reservationId: string }) | null
  >(null);

  const reload = useCallback(() => {
    const requestGeneration = ++generation.current;
    if (!enabled || !restaurantId) return;
    const reservationId = reservation.id;
    fetchReservationProtection(restaurantId, reservationId)
      .then((data) => {
        if (generation.current === requestGeneration) setState({ ...data, restaurantId, reservationId });
      })
      .catch(() => {
        if (generation.current === requestGeneration) setState(null);
      });
  }, [enabled, restaurantId, reservation.id]);

  useEffect(() => {
    reload();
    return () => { ++generation.current; };
  }, [reload, reservation.noShowProtection?.updatedAt, reservation.updatedAt, reservation.status, reservation.guests]);

  return {
    state: enabled && state?.restaurantId === restaurantId && state?.reservationId === reservation.id ? state : null,
    reload,
  };
}
